export default "__VITE_ASSET__538d5df2__"